import { useAuth } from 'context/AuthContext';
import { actionLog } from 'services/actionlog.service';
import { findManagers } from 'services/profile.service';

import { codigosParaAdicionar } from '../equipe-regras';
import { PlayerComRosto, rostoDoPlayer } from '../minha-equipe-calculos';
import ModalDeBusca, { PessoaEncontrada } from './ModalDeBusca';
import { detalheDaPessoa, ExtraDaBusca } from './pessoa-da-busca';

/** Funcionário como o `find/gestores` devolve. */
interface FunciEncontrado extends PlayerComRosto {
  _id: string;
  chave: string;
  nome_guerra?: string;
  name?: string;
  funcao?: string;
  extra?: ExtraDaBusca;
}

export interface ModalAdicionarFuncionarioProps {
  isOpen: boolean;
  onFechar: () => void;
  /** `change_team` registrado: a página fecha o modal, avisa e recarrega a lista. */
  onConcluido: () => void;
}

function paraPessoa(funci: FunciEncontrado): PessoaEncontrada<FunciEncontrado> {
  const funcao = funci.extra?.funcao ?? funci.funcao;
  return {
    id: funci._id,
    nome: funci.nome_guerra ?? funci.name ?? funci._id,
    chave: funci.chave ?? funci._id,
    detalhe: detalheDaPessoa(funci.extra?.diretoria, funcao),
    rosto: rostoDoPlayer(funci),
    dados: funci,
  };
}

/** Inclui na equipe um funcionário que passou a ser liderado depois do planejamento (`change_team`). */
export default function ModalAdicionarFuncionario({ isOpen, onFechar, onConcluido }: ModalAdicionarFuncionarioProps) {
  const { userInfo } = useAuth();

  async function buscar(termo: string) {
    // Sem cod_etapa não há código que o líder possa buscar (mesma guarda do AddEquipe).
    if (!userInfo?.cod_etapa) return [];
    const encontrados: FunciEncontrado[] = await findManagers(termo, codigosParaAdicionar(userInfo.cod_etapa));
    return (Array.isArray(encontrados) ? encontrados : []).filter(funci => funci._id !== userInfo?._id).map(paraPessoa);
  }

  async function confirmar(pessoa: PessoaEncontrada<FunciEncontrado>) {
    await actionLog('me', 'change_team', { player: pessoa.dados.chave, newGestor: userInfo?._id });
    onConcluido();
  }

  return (
    <ModalDeBusca
      isOpen={isOpen}
      titulo="Adicionar funcionário à sua equipe"
      texto="Inclua um funcionário que passou a ser seu liderado depois do fechamento do planejamento da Plataforma Conexão."
      rotuloDoCampo="Funcionário"
      placeholder="Digite o nome ou a chave do funcionário"
      aviso="O funcionário passa a aparecer na sua fila de validação a partir da próxima etapa de apreciação."
      rotuloDoConfirmar="Adicionar"
      buscar={buscar}
      confirmar={confirmar}
      onFechar={onFechar}
    />
  );
}
